<div *ngIf="productService.activeProduct">
  <div>
    <mat-horizontal-stepper #stepper [linear]="true" [selectedIndex]="2" labelPosition="bottom"
      class="stepper-container stepper-disabled-steps">
      <!-- Step 1: visible, not clickable -->
      <mat-step [editable]="false" [completed]="true">
        <ng-template matStepLabel>Grunddaten</ng-template>
        <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
      </mat-step>

      <!-- Step 2: visible, not clickable -->
      <mat-step [editable]="false" [completed]="true">
        <ng-template matStepLabel>Gallerie & Dateien</ng-template>
        <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
      </mat-step>

      <mat-step [completed]="isVariantVersionStepComplete()">
        <ng-template matStepLabel>Variante & Versionen</ng-template>
        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <div></div>
          <button matButton="elevated" color="accent"
            [disabled]="!isVariantVersionStepComplete()"
            (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon> Vorschau
          </button>
        </div>
        <form #form="ngForm">
          <mat-form-field class="fullWidth variant-name-field">
            <mat-label>Variantenname</mat-label>
            <input matInput #variantNameCtrl="ngModel" [(ngModel)]="variant.name"
              name="variantName" required [errorStateMatcher]="variantNameErrorStateMatcher" maxlength="161" minlength="2"
              [ngModelOptions]="{ updateOn: 'change' }" />
            <mat-icon matSuffix class="info-icon"
              matTooltip="Varianten stehen ganz oben rechts auf der Produktübersichtsseite als Drop-Down Menü. Es kann mehrere Varianten für ein Produkt geben. Sie werden verwendet bei unterschiedlichen Produktausführungen für die gleiche Zielgruppe und unterscheiden sich z.b. in Preis und Funktionsumfang. Beispiele: Free, Standard, Professional, Enterprise oder Kostenfrei, Kostenpflichtig oder Concurrent User, Named User. Zusätzliche Versionen können Sie nach Bedarf im Bereich Einstellungen / Produkte ergänzen.​ Produkte für unterschiedliche Zielgruppen (Beispiel: Statiker, Architekt, Haustechnik, … ) bitte ebenfalls separat anlegen."
              matTooltipPosition="above" tabindex="-1">
              info_outline
            </mat-icon>
            <mat-error>
              {{ utilService.getErrorMessage(variantNameCtrl, {fieldName: 'Varianten', includeMinLength: true}) }}
            </mat-error>
          </mat-form-field>
          <!-- <mat-form-field class="fullWidth">
                <textarea
                    matInput
                    placeholder="Kommentar (intern)"
                    [(ngModel)]="variant.comment"
                    name="comment"
                    maxlength="1001"
                ></textarea>
            </mat-form-field> -->
          <app-text-editor [(editorText)]="variant.description"
            (textValidityChange)="onDescriptionValidityChange($event)"></app-text-editor>
          <div>
            <p style="margin-top: 2rem;">
              <em>
                Zum Anlegen einer Variante ist das Anlegen einer Version
                notwendig
              </em>
            </p>
            <app-version-edit [version]="version" [dataType]="'PRODUCT_VARIANT'"
              (validityChanged)="onValidityChanged($event)"></app-version-edit>
          </div>

          <div class="mini-grid-buttons">
            <span class="info-txt">*Pflichtfeld</span>
            <button matButton="elevated" color="warn" (click)="cancelCreateVariant()" style="margin-top: 1vw;">
              Abbrechen
            </button>
            <div></div>
            <div></div>
            <button matButton="elevated" class="green-confirm" (click)="stepper.selectedIndex = 4"
              [disabled]="!isVariantVersionStepComplete()" 
              style="margin-top: 1vw;">Weiter</button>
          </div>
        </form>

      </mat-step>

      <!-- Step 4: visible, not clickable -->
      <mat-step [editable]="false" [completed]="true">
        <ng-template matStepLabel>Übergeordnete Auswahlkriterien</ng-template>
        <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Zusammenfassung</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <button id="savebtn" matButton="elevated" color="accent" (click)="createVariant()">
            Speichern
          </button>
          <button matButton="elevated" color="accent"
            (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon> Vorschau
          </button>

        </div>

        <p class="info-text"><em>Bitte drücken Sie den Vorschau-Button um die Änderungen zu prüfen.</em></p>

        <div class="mini-grid-buttons">
          <button matButton="elevated" color="warn" (click)="cancelCreateVariant()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <div></div>
          <button matButton="elevated" class="green-confirm" style="margin-top: 1vw;"
            (click)="stepper.selectedIndex = 2">Zurück</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>